import * as allRoutes from "../constants/appRoutes";
import { Path as PathParser } from "path-parser";
import { AppStoreActions } from "../redux/services/app/actions";
import QueryString from "qs";
import { AppManager } from ".";
import { APP_ENV } from "../constants/appVars";

/*
 * Volatile paths; path's that shouldn't be remembered when the back
 * action is triggered
 */
const volatilePaths: string[] = [];

const activeWindows: { [k: string]: Window | null } = {};

export class RouteManager {
    private static getRouteQueryString(queryStrings: { [k: string]: string }) {
        let qs = "";

        Object.keys(queryStrings).forEach((key) => {
            if (queryStrings[key]) {
                const value = encodeURIComponent(queryStrings[key]);
                qs = `${qs}${qs.length > 0 ? "&" : ""}${key}=${value}`;
            }
        });

        if (qs.length > 0) {
            return `?${qs}`;
        }
        return "";
    }

    private static formatRoutePath(pathName: string, pathParams?: { [k: string]: string }) {
        pathParams = pathParams || {};

        Object.keys(pathParams).forEach((key) => {
            if (pathParams![key]) {
                const re = RegExp(`/:${key}`);
                pathName = pathName.replace(re, `/${pathParams![key]}`);
            }
        });

        return pathName;
    }

    static gotoLogin(redirectTo?: string): void {
        RouteManager.goto(allRoutes.LOGIN_ROUTE, undefined, redirectTo);
    }

    static gotoOrgAuthorization(): void {
        RouteManager.goto(allRoutes.ORG_AUTHORIZE_ROUTE);
    }

    static gotoSignup(): void {
        RouteManager.goto(allRoutes.SIGNUP_ROUTE);
    }

    static gotoHome(): void {
        RouteManager.gotoOrgAuthorization();
    }

    static gotoLogout(): void {
        RouteManager.goto(allRoutes.LOGOUT_ROUTE);
    }

    static gotoFinancialPlannerSignup() {
        RouteManager.goto(allRoutes.SIGNUP_DEFAULT_PLANNER_ROUTE);
    }

    static gotoDealerGroupSignup() {
        RouteManager.goto(allRoutes.SIGNUP_DEALER_GROUP_ROUTE);
    }

    static gotoDefaultOrganization(orgId: string) {
        const auth = AppManager.auth.getAccessToken()!;
        const qs = RouteManager.getRouteQueryString({ org: orgId, auth });
        window.location.assign(`${APP_ENV.DEFAULT_ORG_ORIGIN}${qs}`);
    }

    static gotoDealerGroupOrganization(orgId: string) {
        const auth = AppManager.auth.getAccessToken()!;
        const qs = RouteManager.getRouteQueryString({ org: orgId, auth });
        window.location.assign(`${APP_ENV.DEALER_GROUP_ORIGIN}${qs}`);
    }

    static canGoBack() {
        return AppStoreActions.getHistory()?.action !== "POP";
    }

    static goBack(preferedBackCall?: () => void): void {
        if (RouteManager.canGoBack()) {
            AppStoreActions.getHistory()?.goBack();
        } else if (preferedBackCall) {
            preferedBackCall();
        } else {
            RouteManager.gotoLogin();
        }
    }

    static goto(route: string, routeParams?: { [k: string]: string }, state?: any, qStrings?: { [k: string]: string }): void {
        const oldPath = AppStoreActions.getHistory()?.location.pathname || "";
        const currentPathname = RouteManager.formatRoutePath(route, routeParams);
        const search = RouteManager.getRouteQueryString(qStrings || {});
        if (volatilePaths.includes(oldPath)) {
            AppStoreActions.getHistory()?.replace({ pathname: currentPathname, state, search } as { pathname: string; state: any });
        } else {
            AppStoreActions.getHistory()?.push({ pathname: currentPathname, state, search } as { pathname: string; state: any });
        }
    }

    static removeQueryPaths() {
        // TODO: Remove it here
        console.log("REMOVING QUERY PATHS FROM ", RouteManager.CURRENT_PATHNAME);
    }

    static get CURRENT_ROUTE(): string {
        const { pathname } = AppStoreActions.getHistory()!.location;
        return Object.values(allRoutes).find((t) => new PathParser(t).test(pathname)) || "";
    }

    static get CURRENT_PATHNAME(): string {
        return AppStoreActions.getHistory()!.location.pathname;
    }

    static get CURRENT_QUERY_STRINGS(): { [k: string]: string } {
        const search = AppStoreActions.getHistory()?.location.search || "";
        return QueryString.parse(search.substring(1) || {}) as { [k: string]: string };
    }
}
